import { render, staticRenderFns } from "./rule-history.vue?vue&type=template&id=7fda578b&"
import script from "./rule-history.vue?vue&type=script&lang=js&"
export * from "./rule-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports